/*
 * @Author: cc
 * @LastEditTime: 2024-08-06 17:49:20
 */
/*
 * @Author: your name
 * @Date: 2020-09-21 19:28:42
 * @LastEditTime: 2021-03-05 17:12:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \exam-s-mobile\src\domain\web-call-app.ts
 */
import { Subject } from "rxjs";
import moment from "moment";
import appCallWeb from "src/harmony/index";
export interface CoreEvents {
  sn: string;
  data?: string;
}

export const serialNumber = () => {
  return Math.random().toString();
};

export let AppCallBackObj: any = {};

export const subject = new Subject<CoreEvents>();

export const AppCommendBackHandlers: any = [];

// export function APPCommendBack() {
//   if (AppCommendBackHandlers.length > 0) {
//     // tslint:disable-next-line: triple-equals
//     if (typeof AppCommendBackHandlers[AppCommendBackHandlers.length - 1] == 'function') {
//       AppCommendBackHandlers[AppCommendBackHandlers.length - 1].call(window);
//     }
//   } else {
//     if (isInApp()) {
//       if (!this.isEmptyObject(AppCallBacks)) {
//         //Elf.components.toast({text:""});
//       } else {
//         webCallApp('CmdGoBack');
//       }
//     } else {
//       history.back(-1);
//     }
//   }
// };

export function webCallApp(command: string, args = {}, callBack?: any) {
  // 如果是鸿蒙系统
    console.log("[鸿蒙] - 入参");
    console.log("window.WebCallApp", appCallWeb.WebCallApp);
    // @ts-ignore
    appCallWeb.WebCallApp(command, args,callBack,window);
}
// 判断是否是微信浏览器
export function isWechat() {
  return /MicroMessenger/i.test(window.navigator.userAgent);
}
// App 设备
export function isInApp() {
  return isInIOS() || isInAndroid() || isInHarmonyOS();
}

export function isInIOS() {
  return !isWechat() && window.webkit && window.webkit.messageHandlers;
}

export function isInAndroid() {
  return typeof window.Elf?.WebCallApp === "function";
}
export function isInHarmonyOS() {
  if (navigator.userAgent.toLowerCase().indexOf("openharmony") !== -1) {
    return true;
  } else {
    return false;
  }
}
function UUID(len: number, radix: number) {
  var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  var uuid = [],
    i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) {
      uuid[i] = chars[0 | (Math.random() * radix)];
    }
  } else {
    var r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join("");
}
export function getSerialNumber() {
  return Math.random().toString(); // new_20240805
}
export const isSafari = !isWechat() && /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
